import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import { variant } from '@styled-system/variant';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('ContainerWithBottomBorder')(({ theme }) =>
  css({
    backgroundColor: 'white',
    borderBottom: `${theme.borders[1]} ${theme.colors.grey[2]}`,
  }),
);

themeStyles.addBaseStyles('AlertsWrapper')(
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    backgroundColor: 'white',
    overflow: 'hidden',
    py: ['16px', '16px', '32px'],
    px: ['20px', '20px', '40px'],
  }),
);

themeStyles.addBaseStyles('Container')(
  ({ theme }) =>
    css({
      display: 'flex',
      backgroundColor: 'white',
      overflow: 'hidden',
      borderBottom: `${theme.borders[1]} ${theme.colors.grey[2]}`,
    }),
  variant({
    prop: 'isExtended',
    variants: {
      normal: {
        flexDirection: 'column',
        pt: ['m', 'm', 0],
        mb: ['-4px', '-4px', 'zero'],
      },
      extended: {
        flexDirection: 'row',
        px: '10px',
      },
    },
  }),
);

themeStyles.addBaseStyles('ContainerRow')(
  css({
    backgroundColor: 'white',
    alignContent: 'center',
  }),
);

themeStyles.addBaseStyles('ProgressContainer')(
  () =>
    css({
      display: 'flex',
      gap: '32px',
      alignItems: ['center', 'center', 'baseline'],
      justifyContent: ['space-between', 'space-between', 'flex-end'],
      backgroundColor: 'white',
      '::-webkit-scrollbar': {
        display: 'none' /* Chrome, Safari and Opera */,
      },
      '-ms-overflow-style': 'none' /* IE and Edge */,
      'scrollbar-width': 'none' /* Firefox */,
    }),
  ({ theme, isExtended, enableSwipe }) =>
    variant({
      prop: 'isExtended',
      variants: {
        normal: {
          width: '100%',
          overflowX: undefined,
          paddingTop: ['s', 's', 'zero'],
          paddingX: ['xs', 'xs', 'zero'],
          borderBottom: [
            `${theme.borders[1]} ${theme.colors.grey[2]}`,
            `${theme.borders[1]} ${theme.colors.grey[2]}`,
            'none',
          ],
        },
        extended: {
          width: 'auto',
          borderBottom: 'none !important',
          overflowX: isExtended && enableSwipe ? 'scroll' : 'noscroll',
        },
      },
    }),
);

themeStyles.addBaseStyles('TitleContainer')(
  css({
    height: '100%',
    display: 'flex',
    alignContent: 'center',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    alignSelf: 'center',
    ml: ['10px', '10px', '36px'],
    pr: '24px',
    fontSize: '14px',
  }),
  variant({
    prop: 'isExtended',
    variants: {
      normal: {
        marginBottom: ['s', 's', 0],
        fontFamily: 'bold',
        lineHeight: '28px',
      },
      extended: {
        pt: ['10px', '10px', 'l'],
        pb: ['10px', '10px', '28px'],
        marginBottom: 0,
        borderBottom: 'none !important',
        flex: 'none',
        fontFamily: 'default',
        width: ['auto', 'auto', '100%'],
        lineHeight: ['22px', '22px', '24px'],
      },
    },
  }),
);

themeStyles.addBaseStyles('Item')(
  ({ isActive, isEnabled }) =>
    css({
      fontFamily: 'bold',
      color: !isActive && !isEnabled && 'grey.0',
      pb: 's',
      pt: ['zero', 'zero', 'm'],
      textAlign: 'center',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
    }),
  ({ theme, isActive }) =>
    variant({
      prop: 'isExtended',
      variants: {
        normal: {
          borderBottom: isActive && [
            `${theme.borders[6]} ${theme.colors.red}`,
            `${theme.borders[6]} ${theme.colors.red}`,
          ],
          paddingLeft: 'xs',
        },
        extended: {
          pt: ['10px', '10px', 'l'],
          pb: isActive ? ['6px', '6px', '28px'] : ['10px', '10px', '28px'],
          borderBottom: isActive && [
            `${theme.borders[5]} ${theme.colors.red}`,
            `${theme.borders[5]} ${theme.colors.red}`,
          ],
          paddingLeft: '0',
        },
      },
    }),
  variant({
    prop: 'variant',
    variants: {
      variant1: {
        fontSize: '14px',
        lineHeight: ['22px', '22px', '24px'],
      },
      variant2: {
        fontSize: '14px',
        lineHeight: ['22px', '22px', '24px'],
      },
    },
  }),
);

export default themeStyles;
